import { ReactNode } from "react"
import Link, { LinkProps } from "next/link"
import clsx from "clsx"
import { CTAButtonLinkSize, CTAButtonLinkVariant, sizeStyles, variantStyles } from "./constants"

interface CTAButtonLinkProps extends LinkProps {
  children: ReactNode
  link?: string
  size?: CTAButtonLinkSize
  variant?: CTAButtonLinkVariant
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  className?: string;
  target?: string
  rel?: string
}

export default function CTAButtonLink({ children, size="large", variant="filled", leftIcon, rightIcon, className, target, rel, ...props }: CTAButtonLinkProps) {
  return (
    <Link 
      aria-label="cta-btn-link" target={target} rel={rel}
      className={clsx("inline-flex items-center justify-center transition-colors rounded-[10px] uppercase",
      sizeStyles[size], variantStyles[variant], className)} {...props}
    >
      {leftIcon && <span className="flex items-center mr-[9px]">{leftIcon}</span>}
      <span>{children}</span>
      {rightIcon && <span className="flex items-center ml-[9px]">{rightIcon}</span>}
    </Link>
  )
}